import type { AppState } from '@app/icare/state/app'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { createUISlice } from './ui/state'

export const useAppState = create<AppState>()(
  persist((...a) => ({ ...createUISlice(...a) }), {
    name: 'app',
    storage: createJSONStorage(() => localStorage),
    partialize: state => ({
      sidebarExpanded: state.sidebarExpanded,
      locked: state.locked,
    }),
  }),
)
